import { render } from "./Card.vue?vue&type=template&id=173920e0"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\PA\\endocorpusa\\web\\app\\plugins\\pa-teams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/components/cards/Card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "173920e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('173920e0', __exports__)) {
    api.reload('173920e0', __exports__)
  }
  
  module.hot.accept("./Card.vue?vue&type=template&id=173920e0", () => {
    api.rerender('173920e0', render)
  })

}


export default __exports__